import { colorsPalettes } from "@similarweb/styles";

import { ACTIVE_ITEM } from "./constants";
import { useLineMetrics } from "./useLineMetrics";
import { AssetsService } from "app/services/AssetsService";

import {
    Wrapper,
    Line,
    ItemDescription,
    Icon,
    IconContainer,
    ItemTextContainer,
    ItemTitle,
    ItemWrapper,
} from "./TimeLineStyled";
import type { ITimeline } from "./types";
import { useTimelineItems } from "./useTimelineItems";

export const Timeline = ({ dueDate, currency, activeItem = ACTIVE_ITEM }: ITimeline) => {
    const items = useTimelineItems({ dueDate, currency });

    const { wrapperRef, lineHeight, activeFillPercentage } = useLineMetrics({
        activeItem,
        totalItems: items.length,
    });

    return (
        <Wrapper ref={wrapperRef}>
            <Line
                $activeFill={activeFillPercentage}
                $height={lineHeight}
            />

            {items.map(({ title, description, iconUrl }, index) => (
                <ItemWrapper
                    key={index}
                    data-timeline-item
                >
                    <IconContainer>
                        <Icon
                            src={AssetsService.assetUrl(iconUrl)}
                            alt="item icon"
                        />
                    </IconContainer>
                    <ItemTextContainer>
                        <ItemTitle
                            fontVariant="subtitle1"
                            color={colorsPalettes.carbon[500]}
                        >
                            {title}
                        </ItemTitle>
                        <ItemDescription
                            fontVariant="body2"
                            color={colorsPalettes.carbon[400]}
                        >
                            {description}
                        </ItemDescription>
                    </ItemTextContainer>
                </ItemWrapper>
            ))}
        </Wrapper>
    );
};
